import { render } from "./cell_boolean.vue?vue&type=template&id=10ce7cd3"
import script from "./cell_boolean.vue?vue&type=script&lang=ts"
export * from "./cell_boolean.vue?vue&type=script&lang=ts"
script.render = render

export default script